import { render, staticRenderFns } from "./vip_chart.vue?vue&type=template&id=07b7b7ee&"
import script from "./vip_chart.vue?vue&type=script&lang=js&"
export * from "./vip_chart.vue?vue&type=script&lang=js&"
import style0 from "./vip_chart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports